import * as XLSX from "xlsx";

export const exportToExcel = ({ fileName = "Export.xlsx", headers = [], rows = [] }) => {
  const data = [
    headers,
    ...rows.map((r) => headers.map((h) => (r?.[h] ?? ""))),
  ];

  const ws = XLSX.utils.aoa_to_sheet(data);

  // Auto width
  const colWidths = headers.map((h, i) => {
    const maxLen = Math.max(
      String(h).length,
      ...rows.map((r) => String(r?.[h] ?? "").length)
    );
    return { wch: Math.min(Math.max(maxLen + 2, 10), 60) };
  });
  ws["!cols"] = colWidths;

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  XLSX.writeFile(wb, fileName);
};
